/* eslint-disable */
import { IntlConfig } from "react-intl";

export const handleTranslationError: IntlConfig["onError"] = (err) => {
    if (err.code !== "MISSING_TRANSLATION" && process.env.NODE_ENV !== "production") {
        console.error(err);
    }
};
